//const serverUrl = 'https://localhost:44378/';
const serverUrl = 'https://backend.zistagram.com/';

const header = () => {
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'apiKey': localStorage.getItem('apiKey'),
    'Cache': 'no-cache',
    'Cache-Control': 'no-store'
  }
};

// User

export const IsAuthorized = () => {
  return fetch(serverUrl + 'api/User/isAuthorized', {
    method: 'POST',
    headers: header()
  });
}

export const Login = (request) => {
  return fetch(serverUrl + 'api/User/Login', {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(request)
  });
}

export const Register = (request) => {
  return fetch(serverUrl + 'api/User/SignUp', {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(request)
  });
}

export const AddUser = (request) => {
  return fetch(serverUrl + 'api/User/add', {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(request)
  });
}

export const GetUsers = (offset, limit) => {
  return fetch(serverUrl + `api/User/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetUser = (userId) => {
  return fetch(serverUrl + `api/user/byId/${userId}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetUsersByUserType = (offset, limit, userType) => {
  return fetch(serverUrl + `api/User${userType ? `/byUserType/${userType}` : ""}/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const EditUser = (userId, request) => {
  return fetch(serverUrl + 'api/User/' + userId, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(request)
  });
}

export const DeleteUser = (userId) => {
  return fetch(serverUrl + `api/User/${userId}`, {
    method: 'DELETE',
    headers: header()
  });
}

export const ForgetPassword = (phoneNumber) => {
  return fetch(serverUrl + 'api/User/forget', {
    method: 'POST',
    headers: header(),
    body: JSON.stringify({ phoneNumber })
  });
}

export const Logout = () => {
  return fetch(serverUrl + 'api/User/logout', {
    method: 'POST',
    headers: header()
  });
}

// Setting

export const GetSettings = () => {
  return fetch(serverUrl + 'api/Setting', {
    method: 'GET',
    headers: header()
  });
}

export const GetSetting = (key) => {
  return fetch(serverUrl + 'api/Setting/ByKey/' + key, {
    method: 'GET',
    headers: header()
  });
}

export const GetSettingById = (settingId) => {
  return fetch(serverUrl + 'api/Setting/' + settingId, {
    method: 'GET',
    headers: header()
  });
}

export const AddSetting = (setting) => {
  return fetch(serverUrl + `api/Setting`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(setting)
  });
}

export const UpdateSetting = (id, setting) => {
  return fetch(serverUrl + `api/Setting/${id}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(setting)
  });
}

export const DeleteSetting = (key) => {
  return fetch(serverUrl + 'api/Setting/' + key, {
    method: 'DELETE',
    headers: header()
  })
}

// Product

export const GetProducts = (offset, limit) => {
  return fetch(serverUrl + `api/Product/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetProductsByBrandAndCategoryAndGroup = (offset, limit, brandId, categoryId, groupId) => {
  return fetch(serverUrl + `api/Product/GetProducts/${offset}/${limit}`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify({ categories: [categoryId], brands: [brandId], groups: [groupId] })
  });
}

export const GetAvailableProducts = (offset, limit) => {
  return fetch(serverUrl + `api/product/available/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetProduct = (productId) => {
  return fetch(serverUrl + `api/product/byId/${productId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddProduct = (product) => {
  return fetch(serverUrl + 'api/product', {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(product)
  });
}

export const EditProduct = (productId, product) => {
  return fetch(serverUrl + `api/product/${productId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(product)
  });
}

export const DeleteProduct = (productId) => {
  return fetch(serverUrl + `api/product/${productId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Brand

export const GetBrands = (offset, limit) => {
  return fetch(serverUrl + `api/brand/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetAllBrands = () => {
  return fetch(serverUrl + `api/brand`, {
    method: 'GET',
    headers: header()
  });
}

export const GetBrand = (brandId) => {
  return fetch(serverUrl + `api/brand/${brandId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddBrand = (brand) => {
  return fetch(serverUrl + 'api/brand', {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(brand)
  });
}

export const EditBrand = (brandId, brand) => {
  return fetch(serverUrl + `api/brand/${brandId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(brand)
  });
}

export const DeleteBrand = (brandId) => {
  return fetch(serverUrl + `api/brand/${brandId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Subject

export const GetSubjects = (offset, limit) => {
  return fetch(serverUrl + `api/subject/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetSubject = (subjectId) => {
  return fetch(serverUrl + `api/subject/${subjectId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddSubject = (subject) => {
  return fetch(serverUrl + `api/subject`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(subject)
  });
}

export const EditSubject = (subjectId, subject) => {
  return fetch(serverUrl + `api/subject/${subjectId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(subject)
  });
}

export const DeleteSubject = (subjectId) => {
  return fetch(serverUrl + `api/subject/${subjectId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Attribute

export const GetAttributes = (offset, limit) => {
  return fetch(serverUrl + `api/attribute/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetAttribute = (attributeId) => {
  return fetch(serverUrl + `api/attribute/ById/${attributeId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddAttribute = (attribute) => {
  return fetch(serverUrl + `api/attribute`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(attribute)
  });
}

export const EditAttribute = (attributeId, attribute) => {
  return fetch(serverUrl + `api/attribute/${attributeId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(attribute)
  });
}

export const DeleteAttribute = (attributeId) => {
  return fetch(serverUrl + `api/attribute/${attributeId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Group

export const GetGroups = (offset, limit) => {
  return fetch(serverUrl + `api/group/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetGroup = (groupId) => {
  return fetch(serverUrl + `api/group/${groupId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddGroup = (group) => {
  return fetch(serverUrl + `api/group`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(group)
  });
}

export const EditGroup = (groupId, group) => {
  return fetch(serverUrl + `api/group/${groupId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(group)
  });
}

export const DeleteGroup = (groupId) => {
  return fetch(serverUrl + `api/group/${groupId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Suggestion

export const GetSuggestions = (offset, limit) => {
  return fetch(serverUrl + `api/suggestion/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetSuggestion = (suggestionId) => {
  return fetch(serverUrl + `api/suggestion/byId/${suggestionId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AnswerSuggestion = (suggestionId, answer) => {
  return fetch(serverUrl + `api/suggestion/answer/${suggestionId}`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify({ "answer": answer })
  });
}

export const DeleteSuggestion = (suggestionId) => {
  return fetch(serverUrl + `api/suggestion/${suggestionId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Complimentary

export const GetComplimentaries = (productId) => {
  return fetch(serverUrl + `api/Complimentary/byProduct/${productId}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetComplimentary = (complimentaryId) => {
  return fetch(serverUrl + `api/Complimentary/ById/${complimentaryId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddComplimentary = (complimentary) => {
  return fetch(serverUrl + `api/Complimentary`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(complimentary)
  });
}

export const EditComplimentary = (complimentaryId, complimentary) => {
  return fetch(serverUrl + `api/Complimentary/${complimentaryId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(complimentary)
  });
}

export const DeleteComplimentary = (complimentaryId) => {
  return fetch(serverUrl + `api/Complimentary/${complimentaryId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// File

export const UploadProductPic = (productId, file) => {
  var formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('UploadDirectory', `img\\product\\${productId}`);

  return fetch(serverUrl + `api/file/upload`, {
    method: 'POST',
    headers: {
      'apiKey': localStorage.getItem('apiKey')
    },
    body: formData
  });
}

export const UploadPostPic = (postId, file) => {
  var formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('UploadDirectory', `img\\post\\${postId}`);

  return fetch(serverUrl + `api/file/upload`, {
    method: 'POST',
    headers: {
      'apiKey': localStorage.getItem('apiKey')
    },
    body: formData
  });
}

export const UploadBannerPic = (bannerId, file) => {
  var formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('UploadDirectory', `img\\banner\\${bannerId}`);

  return fetch(serverUrl + `api/file/upload`, {
    method: 'POST',
    headers: {
      'apiKey': localStorage.getItem('apiKey')
    },
    body: formData
  });
}

export const UploadSliderPic = (file) => {
  var formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('UploadDirectory', `img\\slider`);

  return fetch(serverUrl + `api/file/upload`, {
    method: 'POST',
    headers: {
      'apiKey': localStorage.getItem('apiKey')
    },
    body: formData
  });
}

export const UploadSetting = (file) => {
  var formData = new FormData();
  formData.append('file', file, file.name);
  formData.append('UploadDirectory', `img\\setting`);

  return fetch(serverUrl + `api/file/upload`, {
    method: 'POST',
    headers: {
      'apiKey': localStorage.getItem('apiKey')
    },
    body: formData
  });
}

// Order

export const GetOrders = (offset, limit) => {
  return fetch(serverUrl + `api/purchase/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetOrdersByStatus = (orderStatus, offset, limit) => {
  return fetch(serverUrl + `api/purchase/ByStatus/${orderStatus}/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetOrder = (orderId) => {
  return fetch(serverUrl + `api/purchase/${orderId}`, {
    method: 'GET',
    headers: header()
  });
}

// export const AcceptOrder = (orderId, status) => {
//   return fetch(serverUrl + `api/order/Accept/${orderId}`, {
//     method: 'POST',
//     headers: header(),
//     body: JSON.stringify({ status })
//   });
// }

export const ChangeOrderStatus = (orderId, orderStatus) => {
  return fetch(serverUrl + `api/purchase/ChangeStatus/${orderId}`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify({ orderStatus })
  });
}

export const EditOrder = (orderId, order) => {
  return fetch(serverUrl + `api/purchase/${orderId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(order)
  });
}

export const DeleteOrder = (orderId) => {
  return fetch(serverUrl + `api/purchase/${orderId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Location

export const GetAllLastLocations = () => {
  return fetch(serverUrl + `api/geoLocation`, {
    method: 'GET',
    headers: header()
  });
}

// Post

export const GetPosts = (offset, limit) => {
  return fetch(serverUrl + `api/post/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetPost = (postId) => {
  return fetch(serverUrl + `api/post/byId/${postId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddPost = (post) => {
  return fetch(serverUrl + `api/post`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(post)
  });
}

export const EditPost = (postId, post) => {
  return fetch(serverUrl + `api/post/${postId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(post)
  });
}

export const DeletePost = (postId) => {
  return fetch(serverUrl + `api/post/${postId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Banner

export const GetBanners = (offset, limit) => {
  return fetch(serverUrl + `api/banner/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetBanner = (bannerId) => {
  return fetch(serverUrl + `api/banner/${bannerId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddBanner = (banner) => {
  return fetch(serverUrl + `api/banner`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(banner)
  });
}

export const EditBanner = (bannerId, banner) => {
  return fetch(serverUrl + `api/banner/${bannerId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(banner)
  });
}

export const DeleteBanner = (bannerId) => {
  return fetch(serverUrl + `api/banner/${bannerId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Social Networks

export const GetSocialNetworks = () => {
  return fetch(serverUrl + `api/socialnetwork`, {
    method: 'GET',
    headers: header()
  });
}

export const GetSocialNetwork = (socialNetworkId) => {
  return fetch(serverUrl + `api/socialNetwork/${socialNetworkId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddSocialNetwork = (socialNetwork) => {
  return fetch(serverUrl + `api/socialNetwork`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(socialNetwork)
  });
}

export const EditSocialNetwork = (socialNetworkId, socialNetwork) => {
  return fetch(serverUrl + `api/socialNetwork/${socialNetworkId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(socialNetwork)
  });
}

export const DeleteSocialNetwork = (socialNetworkId) => {
  return fetch(serverUrl + `api/socialNetwork/${socialNetworkId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Offer

export const GetOffers = (offset, limit) => {
  return fetch(serverUrl + `api/offer/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetOffer = (offerId) => {
  return fetch(serverUrl + `api/offer/${offerId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddOffer = (offer) => {
  return fetch(serverUrl + `api/offer`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(offer)
  });
}

export const EditOffer = (offerId, offer) => {
  return fetch(serverUrl + `api/offer/${offerId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(offer)
  });
}

export const DeleteOffer = (offerId) => {
  return fetch(serverUrl + `api/offer/${offerId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Conversation

export const GetConversations = (offset, limit) => {
  return fetch(serverUrl + `api/conversation/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetConversation = (conversationId) => {
  return fetch(serverUrl + `api/conversation/byId/${conversationId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddConversation = (conversation) => {
  return fetch(serverUrl + `api/conversation`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(conversation)
  });
}

export const DeleteConversation = (conversationId) => {
  return fetch(serverUrl + `api/conversation/${conversationId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Message

export const AddMessage = (message) => {
  return fetch(serverUrl + `api/message`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(message)
  });
}

export const EditMessage = (messageId, message) => {
  return fetch(serverUrl + `api/message/${messageId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(message)
  });
}

export const DeleteMessage = (messageId) => {
  return fetch(serverUrl + `api/message/${messageId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// Activity

export const GetActivities = (offset, limit) => {
  return fetch(serverUrl + `api/activity/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetActivity = (activityId) => {
  return fetch(serverUrl + `api/activity/${activityId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddActivity = (activity) => {
  return fetch(serverUrl + `api/activity`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(activity)
  });
}

export const EditActivity = (activityId, activity) => {
  return fetch(serverUrl + `api/activity/${activityId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(activity)
  });
}

export const DeleteActivity = (activityId) => {
  return fetch(serverUrl + `api/activity/${activityId}`, {
    method: 'DELETE',
    headers: header()
  });
}

// ProductType

export const GetProductTypes = (offset, limit) => {
  return fetch(serverUrl + `api/productType/${offset}/${limit}`, {
    method: 'GET',
    headers: header()
  });
}

export const GetProductType = (productTypeId) => {
  return fetch(serverUrl + `api/productType/${productTypeId}`, {
    method: 'GET',
    headers: header()
  });
}

export const AddProductType = (productType) => {
  return fetch(serverUrl + `api/productType`, {
    method: 'POST',
    headers: header(),
    body: JSON.stringify(productType)
  });
}

export const EditProductType = (productTypeId, productType) => {
  return fetch(serverUrl + `api/productType/${productTypeId}`, {
    method: 'PUT',
    headers: header(),
    body: JSON.stringify(productType)
  });
}

export const DeleteProductType = (productTypeId) => {
  return fetch(serverUrl + `api/productType/${productTypeId}`, {
    method: 'DELETE',
    headers: header()
  });
}
